import React from 'react';
import { KrUpdateModalManager } from '@workboard/ui-okr';

export const withKrUpdateManager = (Component, location) => (props) => {
  const uploadFile = (file) => window.FUS.uploadFile(file)
  
  return (
    <KrUpdateModalManager mixpanelLocation={location} mixpanelLocationDetail={window.location.href} uploadFile={uploadFile}>
      <Component {...props} />
    </KrUpdateModalManager>
  )
}
